import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";

import {confirm} from "../../../../utils/confirmDialog";
import {NotificationManager} from "react-notifications";
import {addGlobalError} from "../../../../actions/globalerror";

class Membergames extends React.Component {
    static propTypes = {
        data: PropTypes.array.isRequired,
        setEditMode: PropTypes.func.isRequired,
        updateRow: PropTypes.func.isRequired,
        deleteRow: PropTypes.func.isRequired,
        acceptRow: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            editIx: null,
        };
    }

    fields = [];
    render() {
        return <div>
            <table className="data-table">
                <thead>
                <tr>
                    <th></th>
                    <th>Fejltekst</th>
                    <th className="center">Uge</th>
                    <th className="center">Foren</th>
                    <th className="center">KFK</th>
                    <th className="center">Slag</th>
                    <th>Vers.</th>
                </tr>
                </thead>
                <tbody>
                {this.props.data.map((row, ix) => ix === this.state.editIx ? <tr key={ix} className="edit-row">
                    <th scope="row" style={{minWidth: '80px'}}>
                        <i className="fa fa-save clickable" title="Gem station" onClick={() => {
                            if (this.allInputValid()) {
                                this.props.updateRow({
                                    Uge: row.Uge,
                                    Foreningsnr: row.Foreningsnr,
                                    Slag: row.Slag,
                                    KFK: row.KFK,
                                }, {
                                    Uge: this.state.Uge === '' ? null : this.state.Uge,
                                    Foreningsnr: this.state.Foreningsnr === '' ? null : this.state.Foreningsnr,
                                    Slag: this.state.Slag === '' ? null : this.state.Slag,
                                    KFK: this.state.KFK === '' ? null : this.state.KFK,
                                }, () => {
                                    NotificationManager.success("Slagspil for slag " + this.state.Slag + " i forening " + this.state.Foreningsnr + " på flyvning " + this.state.KFK + " er opdateret.", "Opdatering", 4000);
                                    this.setState({editIx: null});
                                    this.props.setEditMode(false);
                                });
                            } else {
                                this.fields.forEach((field) => {
                                    field.setState({visited: true});
                                });
                            }
                        }}/>
                        <i className="fa fa-undo clickable" title="Annuller" onClick={() => {
                            this.setState({editIx: null});
                            this.props.setEditMode(false);
                        }}/>
                    </th>
                    <td>{row.Fejltekst === null ? '' : row.Fejltekst}</td>
                    <td className="center">
                        <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                          name="Uge" id="Uge" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{1,2}"}]} value={this.state.Uge}
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[0] = instance; }}
                        />
                    </td>
                    <td className="center">
                        <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                          name="Foreningsnr" id="Foreningsnr" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]} value={this.state.Foreningsnr}
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[1] = instance; }}
                        />
                    </td>
                    <td className="center">
                        <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                          name="Slag" id="Slag" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]} value={this.state.Slag}
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[2] = instance; }}
                        />
                    </td>
                    <td className="center">
                        <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                          name="KFK" id="KFK" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}"}]} value={this.state.KFK}
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[3] = instance; }}
                        />
                    </td>
                    <td>{row.Programversion === null ? '' : row.Programversion}</td>
                </tr> : <tr key={ix}>
                    <th scope="row" style={{minWidth: '80px'}}>
                        <i className={"fa fa-pencil " + (this.state.editIx === null ? 'clickable' : 'disabled')} title="Rediger række" onClick={() => {
                            if (this.state.editIx === null) this.setState({
                                Uge: row.Uge === null ? '' : row.Uge,
                                Foreningsnr: row.Foreningsnr === null ? '' : row.Foreningsnr,
                                Slag: row.Slag === null ? '' : row.Slag,
                                KFK: row.KFK === null ? '' : row.KFK,
                                editIx: ix,
                            });
                            this.props.setEditMode(true);
                        }}/>
                        <i className={"fa fa-trash " + (this.state.editIx === null ? 'clickable' : 'disabled')} title="Slet række" onClick={() => {
                            if (this.state.editIx === null) confirm("Slet", <span>Ønsker du at slette slagspil for slag <b>{row.Slag}</b> i forening <b>{row.Foreningsnr}</b> på flyvning <b>{row.KFK}</b>?</span>, () => {
                                this.props.deleteRow([{
                                    Uge: row.Uge,
                                    Foreningsnr: row.Foreningsnr,
                                    Slag: row.Slag,
                                    KFK: row.KFK,
                                }], () => {
                                    NotificationManager.success("Slagspil for slag " + row.Slag + " i forening " + row.Foreningsnr + " på flyvning " + row.KFK + " er slettet.", "Sletning", 4000);
                                });
                            });
                        }}/>
                        <i className={"fa fa-check " + (this.state.editIx === null ? 'clickable' : 'disabled')} title="Accepter række" onClick={() => {
                            if (this.state.editIx === null) confirm("Accepter", <span>Ønsker du at acceptere slagspil for slag <b>{row.Slag}</b> i forening <b>{row.Foreningsnr}</b> på flyvning <b>{row.KFK}</b>?</span>, () => {
                                this.props.acceptRow([{
                                    Uge: row.Uge,
                                    Foreningsnr: row.Foreningsnr,
                                    Slag: row.Slag,
                                    KFK: row.KFK,
                                }], (response) => {
                                    if (response.failed.length > 0) this.props.dispatch(addGlobalError('Fejl ved accept', response.failed[0].msg, -1));
                                    else NotificationManager.success("Slagspil for slag " + row.Slag + " i forening " + row.Foreningsnr + " på flyvning " +row.KFK + " er accepteret.", "Accept", 4000);
                                });
                            });
                        }}/>
                    </th>
                    <td>{row.Fejltekst === null ? '' : row.Fejltekst}</td>
                    <td className="center">{row.Uge === null ? '' : row.Uge}</td>
                    <td className="center">{row.Foreningsnr === null ? '' : row.Foreningsnr}</td>
                    <td className="center">{row.Slag === null ? '' : row.Slag}</td>
                    <td className="center">{row.KFK === null ? '' : row.KFK}</td>
                    <td>{row.Programversion === null ? '' : row.Programversion}</td>
                </tr>)}
                </tbody>
            </table>
        </div>
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field, ix) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    getAllKeys = () => {
        return this.props.data.map(row => ({
            Uge: row.Uge,
            Foreningsnr: row.Foreningsnr,
            Slag: row.Slag,
            KFK: row.KFK,
        }));
    };
}

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, null, null, {withRef: true})(Membergames);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/errorLists/subPages/Membergames.js